import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import * as configActions from '../../../redux/config/actions.config';
import * as userActions from '../../../redux/user/actions.user';
import * as analyticsActions from '../../../redux/analytics/actions.analytics';
import * as organizationActions from '../../../redux/organization/actions.organization';
import MainHeader from '../../headers/MainHeader/MainHeader';
import isLocalStorageAvailable from '../../../services/mini/isLocalStorageAvailable';
import getDeviceId from '../../../services/mini/getDeviceId';
import getPageTitle from '../../../services/mini/getPageTitle';
import asyncDispatch from '../../../services/mini/asyncDispatch';
import BillingTile from './BillingTile/BillingTile';
import BillingTileHeader from './BillingTileHeader/BillingTileHeader';
import BillingCurrentPlan from './BillingCurrentPlan/BillingCurrentPlan';
import BillingPageBalanceInfo from './BillingPageBalanceInfo/BillingPageBalanceInfo';
import BillingHistory from './BillingHistory/BillingHistory';
import BillingChart from './BillingChart/BillingChart';
import BillingConnectToGithub from './BillingConnectToGithub/BillingConnectToGithub';
import HistoryKeeper from '../../../services/HistoryKeeper';
import { pages, actions } from '../../../const/plansAnalytics';
import { Loader } from '../../components/Loader/Loader';
import BillingHeader from './BillingHeader';
import { confirmAlert } from '../../../services/mini/alanConfirmAlert';
import ConfirmPopup from '../../components/ConfirmPopup/ConfirmPopup';

const BILLING_CONTENT_ID = 'billing_payment_forms';
const DEF_CONTENT_VERSION = '0.0.1';
const DEF_CONTENT_VERSION_TAG = 'v1';


class BillingPage extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            contentVersion: null,
            contentVersionTag: null
        };
    }

    componentDidMount() {
        const { getPlans, trackPlanAction } = this.props;

        document.title = getPageTitle('Billing');

        getPlans().catch(() => { });

        this.fillContentVersion(this.props, this.state);

        HistoryKeeper.push();

        trackPlanAction({ page: pages.billing, action: actions.openPage });
    }

    componentWillReceiveProps(nextProps, nextState) {
        this.fillContentVersion(nextProps, nextState);
    }

    fillContentVersion(props, state) {
        const {
            getStudioConfig,
            email
        } = props;

        if (state.contentVersion && state.contentVersionTag) return;

        if (!email) return;

        let storedContentVersion;
        const storedContentVersionKey = `billing-content-version-${getDeviceId()}-${email}`;
        const hasStorage = isLocalStorageAvailable();

        storedContentVersion = hasStorage ? localStorage.getItem(storedContentVersionKey) : window[storedContentVersionKey];

        if (!storedContentVersion) {
            getStudioConfig().then((config) => {
                const viewConfig = config[BILLING_CONTENT_ID] || {};
                const random = Math.random();
                const contentVersion = viewConfig.contentVersion || DEF_CONTENT_VERSION;
                let contentVersionTag = DEF_CONTENT_VERSION_TAG;

                if (viewConfig.chance) {
                    const versionTags = Array.from({ length: Math.floor(1 / viewConfig.chance) }, (_, ind) => `v${ind + 1}`);
                    contentVersionTag = versionTags[Math.floor(Math.random() * versionTags.length)];
                }

                console.info("PAYMENT ANALYTICS", config, random);

                this.setState({
                    contentVersion,
                    contentVersionTag
                });

                storedContentVersion = `${contentVersion}_${contentVersionTag}`;

                if (hasStorage) {
                    localStorage.setItem(storedContentVersionKey, storedContentVersion);
                } else {
                    window[storedContentVersionKey] = storedContentVersion;
                }
            });
        } else {
            const [contentVersion, contentVersionTag] = storedContentVersion.split('_');
            this.setState({
                contentVersion,
                contentVersionTag
            });
        }
    }

    render() {
        const {
            isInitialBilling,
            balance,
            githubLogin,
            currentPlan,
            paidUntilTs,
            cancelPlanTs,
            billingStatus,
            freeInteractions,
            cancelEnterpriseSubscription,
            resumeEnterpriseSubscription,
            plans,
            cards,
            memberOf,
            orgAdminEmail,
            email
        } = this.props;

        const isEnterprise = currentPlan?.isEnterprise;

        return (
            <div className="billing-page">
                <MainHeader>
                    <BillingHeader />
                </MainHeader>

                <div className="billing-page_content">
                    {memberOf ?
                        <div className="billing-page_inner-content-for-organization-users">
                            <BillingTile>
                                <BillingTileHeader>
                                    Balance/Interactions
                                </BillingTileHeader>
                                Organization: <b>{memberOf}</b><br />
                                <br />
                                Billing managed by <b>{orgAdminEmail}</b>
                                <br />
                                <br />
                                <br />
                                <div onClick={() => {
                                    confirmAlert({
                                        customUI: ({ onClose }) => {
                                            return (
                                                <ConfirmPopup
                                                    onClose={onClose}
                                                    okBtnLabel="Leave"
                                                    okBtnCb={() => {
                                                        onClose();
                                                        this.props.removeOrganizationMember({ email });
                                                    }}
                                                    title="Leave organization"
                                                    message={<div>Are you sure you want to leave the <b>{memberOf}</b> organization?</div>}
                                                />
                                            );
                                        }
                                    });
                                }} className="action-btn middle">Leave</div>

                            </BillingTile>
                        </div> :
                        <>
                            {!_.isEmpty(currentPlan) ?
                                <div className="billing-page_inner-content">
                                    <BillingChart />
                                    <BillingTile className="billing-right-part">
                                        {!isEnterprise &&
                                            <>
                                                <BillingPageBalanceInfo
                                                    plan={currentPlan}
                                                    balance={balance}
                                                    billingStatus={billingStatus}
                                                    freeInteractions={freeInteractions}
                                                />
                                                <br />
                                                <br />
                                            </>

                                        }

                                        <BillingCurrentPlan
                                            plan={currentPlan}
                                            cards={cards}
                                            plansCount={plans.length}
                                            paidUntilTs={paidUntilTs}
                                            cancelPlanTs={cancelPlanTs}
                                            cancelEnterpriseSubscription={cancelEnterpriseSubscription}
                                            resumeEnterpriseSubscription={resumeEnterpriseSubscription}
                                        />
                                    </BillingTile>

                                    <BillingTile className="billing-history-wrapper">
                                        <BillingHistory />
                                    </BillingTile>

                                </div> :
                                <Loader theme="light" size="big" center={true} />}
                        </>}

                </div>
            </div>
        );
    }
}

function mapStateToProps({ user }, ownProps) {
    let tab = '';
    if (ownProps.route && ownProps.route.tab) {
        tab = ownProps.route.tab;
    }

    return {
        hasPaymentInfo: user.hasPaymentInfo,
        isInitialBilling: user.tier === "free",
        tab: tab,
        email: user.email,
        tier: user.tier,
        githubLogin: user.githubLogin,
        balance: user.balance,
        paidUntilTs: user.paidUntilTs,
        cancelPlanTs: user.cancelPlanTs,
        currentPlan: user.currentPlan,
        billingStatus: user.billingStatus,
        freeInteractions: user.freeInteractions,
        plans: user.plans,
        cards: user.cards,
        memberOf: user.memberOf,
        orgAdminEmail: user.orgAdminEmail,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getPlans: (param) => asyncDispatch(userActions.getPlans, dispatch, param),
        getUserPaymentMethods: (param) => asyncDispatch(userActions.getUserPaymentMethods, dispatch, param),
        cancelEnterpriseSubscription: (param) => asyncDispatch(userActions.cancelEnterpriseSubscription, dispatch, param),
        resumeEnterpriseSubscription: (param) => asyncDispatch(userActions.resumeEnterpriseSubscription, dispatch, param),
        getStudioConfig: (param) => asyncDispatch(configActions.getStudioConfig, dispatch, param),
        trackPlanAction: (param) => asyncDispatch(analyticsActions.trackPlanAction, dispatch, param),
        removeOrganizationMember: (param) => asyncDispatch(organizationActions.removeOrganizationMember, dispatch, param),

    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BillingPage);
